<template>
  <Modal class="long-modal" width="900" style="max-height:80%; over-flow:auto" v-model="show" :mask-closable="false"
         :loading="loading">
    <div slot="header" class="modal-header">{{'跟进记录' }}</div>

    <!--  -->
    <div class="readOnly" v-if="formData">
      <div v-if="formData.customerName">姓名：
        {{formData.customerName}}
        {{formData.customerGenderText}}
      </div>
      <div v-if="formData.customerPhone">电话：
        {{formData.customerPhone}}
      </div>
      <ul class="check"
          v-if="formData.businessFromChannel||formData.channelPhone||formData.channelNameAndCode||formData.businessMessage1">
        <!-- <div class="shu">渠道信息</div> -->
        <li v-if="formData.businessFromChannel">推荐渠道：{{formData.businessFromChannelText}}</li>
        <li v-if="formData.channelPhone">渠道人手机号：{{formData.channelPhone}}</li>
        <li v-if="formData.channelNameAndCode">渠道人信息：{{formData.channelNameAndCode}}</li>
        <li v-if="formData.businessMessage1">推荐客户需求描述：{{formData.businessMessage1}}</li>
      </ul>



      <div v-if="formData.companyName">公司名称：
        {{formData.companyName}}
      </div>
      <div v-if="formData.stayPersonTypeName">入住人类型：
        {{formData.stayPersonTypeName}}
      </div>
      <div v-if="formData.ageRangeName">年龄分布：
        {{formData.ageRangeName}}
      </div>

      <div v-if="formData.companyScaleName">公司规模：
        {{formData.companyScaleName}}
      </div>
      <div v-if="formData.paySubject">付费主体：
        {{formData.paySubjectName}}
      </div>

      <div v-if="formData.reimbursementRangeName">报销金额：
        {{formData.reimbursementRangeName}}
      </div>




      <div v-if="formData.houseTypeFidText">带看意向房型：
        {{formData.houseTypeFidText}}
      </div>
      <div v-if="formData.intentionInTime">期望入住时间：
        {{formData.intentionInTime}}
      </div>
      <div v-if="formData.budgetRangeText">预算范围：
        {{formData.budgetRangeText}}
      </div>
      <div v-if="formData.checkinNum">几人居住：
        {{formData.checkinNum}}
      </div>
      <div v-if="formData.houseTypeText">找房意向户型：
        {{formData.houseTypeText}}
      </div>
      <div v-if="formData.intentionAreaText">意向面积：
        {{formData.intentionAreaText}}
      </div>
      <div v-if="formData.workAddressName">工作地点：
        {{formData.workAddressName}}
      </div>
      <div v-if="formData.rentPeriodText">期望租住时长：
        {{formData.rentPeriodText}}
        <span v-if="formData.rentPeriod == 1">{{formData.rentNumber}}年</span>
        <span v-if="formData.rentPeriod == 2">{{formData.rentNumber}}月</span>
      </div>
      <div v-if="formData.clientTypeText">短租用途：
        {{formData.clientTypeText}}
      </div>
      <div v-if="formData.commutingModeText">通勤方式：
        {{formData.commutingModeText}}
      </div>
      <div v-if="formData.commutingDuration">期望通勤时长：
        {{formData.commutingDuration}}
      </div>
      <div v-if="formData.residenceName">现住地点：
        {{formData.residenceName}}
      </div>
      <div v-if="formData.currentStatusName">工作状态：
        {{formData.currentStatusName}}
      </div>
      <div v-if="formData.grade">商机等级：
        {{formData.grade}}
      </div>
    </div>
    <Tabs v-model="currentTab" class="toph-tabs">
      <TabPane label="跟进记录" name="HISTORY"></TabPane>
      <TabPane label="客户档案" name="PROFILE"></TabPane>
      <TabPane label="重复商机" name="BUSINESS_RECORDS"></TabPane>
    </Tabs>
    <keep-alive>
      <div v-if="currentTab=='HISTORY'">
        <table-list
          title=""
          :columns="columns"
          :data="tabelData"
          :loading="tableLoading"
          :showPage="false"
        ></table-list>
      </div>
    </keep-alive>
    <keep-alive>
      <div v-if="currentTab=='PROFILE'">
        <table-list
          title="浏览记录"
          :columns="browseColumns"
          :data="browseTabelData"
          :loading="browseTableLoading"
          :current="browseCurrent"
          :total="browseTotal"
          @change-page="browseChangPage"
          :pageSize="5"
        ></table-list>

        <table-list
          title="收藏信息"
          :columns="collecitonColumns"
          :data="collectionTabelData"
          :loading="collectionTableLoading"
          :current="collectionCurrent"
          :total="collectionTotal"
          @change-page="collectionChangPage"
        ></table-list>

        <table-list
          title="历史合同"
          :columns="contractColumns"
          :data="contractTabelData"
          :loading="contractTableLoading"
          :showPage="false"
        ></table-list>
      </div>
    </keep-alive>
    <keep-alive>
      <div v-if="currentTab=='BUSINESS_RECORDS'">
        <table-list
          title=""
          :columns="businessRecordColumns"
          :data="businessRecordsTableData"
          :loading="tableLoading"
          :showPage="false"
        ></table-list>
      </div>
    </keep-alive>
    <div slot="footer"></div>
  </Modal>
</template>
<script type="text/ecmascript-6">

  import {
    getSelectedData,
    getDetail,
    getHandleList,
    handleBusiness,
    getContractCode,
    isHaveLookBusiness,
    getContractHistory,
    getBrowseHistory,
    getCollectionHistory,
    getAllBusinessRecords
  } from 'api/business'
  import {getProjectHouseType} from 'api/common'
  import {formatDateTime} from '@/utils/format'
  import TableList from 'components/TableList/index';
  import CancelModal from 'components/CancelModal/index';
  import MsgTip from './MsgTip';
  import Location from 'components/Location/index'

  export default {
    props: {
      n: {
        type: Number,
        default: 0
      },
      data: {
        type: Object,
        default: null
      }

    },
    components: {
      TableList,
      MsgTip,
      CancelModal,
      Location
    },
    watch: {
      n(val) {
        this.currentTab = "HISTORY"
        this.loading = false
        this.show = true;

        this.tabelData = []

        this.browseCurrent = 1
        this.browseTotal = 0
        this.collectionCurrent = 1
        this.collectionTotal = 0
        this.browseTableLoading = false
        this.collectionTableLoading = false
        this.contractTableLoading = false
        this.browseTabelData = []
        this.collectionTabelData = []
        this.contractTabelData = []

        if (this.data) {
          this.initData(this.data.businessFid)

        }
      },
    },
    data() {
      return {
        currentTab: "HISTORY",
        show: false,
        loading: false,
        // lable:'跟进时间',
        // showLookRadio:false,
        // showHistoryKey:0,
        tableLoading: true,
        contract: '',
        businessMessage: null,
        columns: [
          {
            title: '跟进时间',
            key: 'followUpTime',
            align: 'center',
            width: 160
          },
          {
            title: '跟进人',
            key: 'followUpUser',
            align: 'center',
            width: 80
          },
          {
            title: '跟进结果',
            key: 'followUpResult',
            align: 'center',
          },
          {
            title: '备注',
            key: 'remark',
            align: 'center',
            render: (h, params) => {
              if (params.row['remark'] && params.row['remark'].length > 40) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['remark']),
                  h('div', {
                    style:
                      {'line-height': '25px !important'}
                  }, params.row['remark'].slice(0, 40) + '...')
                ])
              } else {
                return h('div', {}, params.row['remark'])
              }

            }
          }
        ],
        businessRecordColumns: [
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            width: 110
          },
          {
            title: '看房时间',
            key: 'visitTime',
            align: 'center',
            width: 110
          },
          {
            title: '意向房型',
            key: 'houseType',
            align: 'center',
            width: 120
          },
          {
            title: '来源渠道',
            key: 'businessChannel',
            align: 'center',
            width: 110
          },
          {
            title: '用户留言',
            key: 'businessMessage',
            align: 'center',
          }
        ],
        tabelData: [],
        formData: null,
        chanelList: [],
        residenceArr: [],
        workAddressArr: [],
        houseTypeFidList: [],
        disabledIsLook: null,

        //客户档案
        customerUid: '',
        browseTableLoading: true,
        collectionTableLoading: true,
        contractTableLoading: true,
        businessRecordsTableLoading: true,
        browseCurrent: 1,
        browseTotal: 0,
        collectionCurrent: 1,
        collectionTotal: 0,
        browseColumns: [
          {
            title: '浏览对象',
            key: 'browseMsg',
            align: 'center'
          },
          {
            title: '最近浏览时间',
            key: 'browseLatelyTimeStr',
            align: 'center'
          },
          {
            title: '浏览次数',
            key: 'browseTotalCount',
            align: 'center'
          }
        ],
        collecitonColumns: [
          {
            title: '收藏对象',
            key: 'collectionObjName',
            align: 'center'
          },
          {
            title: '收藏时间',
            key: 'collectionTimeStr',
            align: 'center'
          }
        ],
        contractColumns: [
          {
            title: '项目名称',
            key: 'projectName',
            align: 'center',
            width: 200
          },
          {
            title: '房间名称',
            key: 'roomName',
            align: 'center',
            width: 100
          },
          {
            title: '合同开始日期',
            key: 'startDateStr',
            align: 'center',
            width: 160
          },
          {
            title: '合同截止日期',
            key: 'endDateStr',
            align: 'center',
            width: 160
          },
          {
            title: '月租金',
            key: 'amount',
            align: 'center',
            width: 160
          },
          {
            title: '合同状态',
            key: 'contractStatus',
            align: 'center',
            width: 100
          },
          {
            title: '合同来源',
            key: 'type',
            align: 'center',
            width: 100
          }
        ],
        browseTabelData: [],
        collectionTabelData: [],
        contractTabelData: [],
        businessRecordsTableData: [],
      };
    },
    methods: {
      initData(businessFid) {
        getDetail(businessFid).then(res => {
          if (!res.data) {
            return
          }
          this.formData = res.data
          this.customerUid = res.data.customerUid;

          if (this.customerUid) {
            this.initProfile(this.customerUid);
          }
          if (this.formData.customerGender == 1) {
            this.formData.customerGenderText = '女'
          } else if (this.formData.customerGender == 2) {
            this.formData.customerGenderText = '男'
          } else {
            this.formData.customerGenderText = ''
          }
        }).catch(res => {
        })

        getHandleList(businessFid).then(res => {
          this.tabelData = res.data.rows
          this.tableLoading = false
        }).catch(error => {
          this.tableLoading = false
        })
        this.initBusinessRecords(this.data.businessFid);

      },
      close() {
        this.show = false
      },
      //客户档案
      browseChangPage(n) {
        this.browseTableLoading = true;
        this.browseCurrent = n;
        this.initBrowseTableList(this.customerUid, n, 5);
      },
      initBrowseTableList(customerUid, page, limit) {
        getBrowseHistory(customerUid, page, limit).then(res => {
          if (res.code == 0) {
            this.browseTabelData = res.data.rows
            this.browseTotal = res.data.total
          } else {
            this.$Message.warning(res.message);
          }
          this.browseTableLoading = false
        }).catch(() => {
          this.browseTableLoading = false
        });
      },
      collectionChangPage(n) {
        this.collectionTableLoading = true;
        this.collectionCurrent = n;
        this.initCollectionTableList(this.customerUid, n, 5);
      },
      initCollectionTableList(customerUid, page, limit) {
        getCollectionHistory(customerUid, page, limit).then(res => {
          if (res.code == 0) {
            this.collectionTabelData = res.data.rows
            this.collectionTotal = res.data.total
          } else {
            this.$Message.warning(res.message);
          }
          this.collectionTableLoading = false
        }).catch(() => {
          this.collectionTableLoading = false
        });
      },
      initContractTableList(customerUid) {
        getContractHistory(customerUid).then(res => {
          if (res.code == 0) {
            this.contractTabelData = res.data
          } else {
            this.$Message.warning(res.message);
          }
          this.contractTableLoading = false
        }).catch(() => {
          this.contractTableLoading = false
        });
      },
      initProfile(customerUid) {
        this.initContractTableList(customerUid);
        this.initCollectionTableList(customerUid, 1, 5);
        this.initBrowseTableList(customerUid, 1, 5);
      },
      initBusinessRecords(businessFid) {
        getAllBusinessRecords(businessFid).then(res => {
          if (res.code == 0) {
            this.businessRecordsTableData = res.data
          } else {
            this.$Message.warning(res.message);
          }
          this.businessRecordsTableLoading = false
        }).catch(() => {
          this.businessRecordsTableLoading = false
        });
      }
    }
  }
</script>
<style scoped>

  .icon-wrap {
    display: inline;
  }

  .half-w {
    width: 50%;

  }

  .error-tip {
    position: absolute;
    color: #F56356;
  }

  .ivu-date-picker {
    width: 100%;
  }

  .old {
    color: red;
    line-height: 18px;
  }

  .red {
    color: #CFA868;
    display: inline-block;
    width: 80px;
  }

  .check {
    width: 95%;
    margin-left: 16px;
    border: 1px dashed;
    padding: 16px 16px 0 30px;
    background: #eee;
    margin-bottom: 20px;
    position: relative;
  }

  .check li {
    width: 46%;
    margin-bottom: 16px;
    display: inline-block;
  }

  .shu {
    width: 20px;
    position: absolute;
    height: 80px;
    left: 5px;
    top: 6px;

  }

  .readOnly div {
    width: 47%;
    margin-bottom: 16px;
    margin-left: 16px;
    display: inline-block;
  }

  .marB0 {
    margin-bottom: 0;
  }

  .contract-code-box {
    line-height: 32px;
    font-weight: bolder;
  }
</style>
<style>
  .zIndex .ivu-form-item-content {
    z-index: 99;
  }
</style>

